import React from 'react';

// DEPENDENCIES
import HTMLReactParser from 'html-react-parser';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { apiFetch, doCallback, formatDate } from 'functions.js';

// CONTEXT
import { useRecordContext } from 'helpers/getRecordData';

// BOOTSTRAP COMPONENTS
import { Badge, Col, Row } from 'react-bootstrap';

// CORE COMPONENTS
import Form from 'core/form/Form';

// LOCAL PARTS
import DealTaskComment from './DealTaskComment';
import DealTaskCommentForm from './DealTaskCommentForm';

// STYLES
import styles from './dealTasksItem.module.scss';

// MAIN COMPONENT
const DealTasksItem = ({
  number,
  name,
  aryComment,
  comments,
  task_createdby_full_name,
  task_completedby_full_name,
  task_date_created,
  task_date_updated,
  task_id
}) => {

  // CONTEXT
  const { refetchRecord } = useRecordContext() || {};
  
  // CALLBACKS
  const handleComplete = () => {
    apiFetch({
      method: 'PUT',
      endpoint: ENDPOINTS.dealTasks.complete,
      params: {
        task_id,
        is_completed: 1
      },
      loadingMessage: 'Completing task',
      successMessage: 'Task completed successfully.',
      errorMessage: 'Unable to complete task.',
      onSuccess: () => doCallback(refetchRecord)
    });
  };

  // RENDER
  return (
    <div className={styles.item}>
      <Badge className={styles.numberPill} bg="secondary" pill>{number}</Badge>
      <div className={styles.header}>
        <div className={styles.title}>{HTMLReactParser(comments)}</div>
        {!task_completedby_full_name &&
          <Form.Checkbox
            className={styles.checkbox}
            onChange={handleComplete}
          />
        }
      </div>
      <Row className={styles.metaData}>
        {[{
          label: 'Created By',
          value: task_createdby_full_name
        }, {
          label: 'Created On',
          value: formatDate(task_date_created)
        },
        ...(task_completedby_full_name ? [{
          label: 'Completed By',
          value: task_completedby_full_name
        }, {
          label: 'Completed On',
          value: formatDate(task_date_updated)
        }] : [])].map(({ label, value }, j) => (
          <Col key={j} xs={6} className={styles.metaDatum}>
            <span className={styles.label}>{label}</span>
            <span className={styles.value}>{value}</span>
          </Col>              
        ))}
      </Row>
      <div className={styles.container}>
        <span className={styles.label}>Comments</span>
        <div className={styles.comments}>
          {aryComment.map((comment, i) => (
            <DealTaskComment key={i} name={name} comment={comment} />
          ))}
        </div>
        <DealTaskCommentForm taskID={task_id} />
      </div>
    </div>
  );
};

// EXPORT
export default DealTasksItem;
